import { useRef, useEffect } from 'react';

function useAccessibilityWarning(props) {
  var selected = props.selected,
    label = props.label;
  var initialSelected = useRef(selected);
  var initialLabel = useRef(label);
  useEffect(function () {
    if (process.env.NODE_ENV !== "production") {
      if (initialSelected.current !== selected && initialLabel.current !== label) {
        // eslint-disable-next-line no-console
        console.warn("CheckButton: To avoid confusion for screen reader users the \"label\" prop should not change when the \"selected\" prop changes. \n          Examples of screen reader output depending on the props: \n          \n          GOOD: \n            * label=\"Mute\", selected=false => \"Mute, toggle button, not pressed\".\n            * GOOD: label=\"Mute\", selected=true => \"Mute, toggle button, pressed\".\n          \n          BAD (both scenarios indicate that it's currently unmuted):  \n            * label=\"Mute\", selected=false => \"Mute, toggle button, not pressed\".\n            * label=\"Unmute\", selected=true => \"Unmute, toggle button, pressed\".\n          ");
      }
    }
  }, [label, selected]);
}

export { useAccessibilityWarning };
